import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import Icons from "../assest/icon.png";
function Footer() {
  return (
    <footer className="bg-[#4a2f52] text-white px-6 md:px-[100px] py-[50px] md:py-[60px]">
      {/* TOP SECTION */}
      <div className="flex flex-col md:flex-row justify-between gap-10 flex-wrap">
        {/* LOGO + SOCIAL */}
        <div className="max-w-[250px]">
          <div className="flex flex-col items-start gap-2 mb-5">
            <img src={Icons} alt="logo" className="w-[40px]" />
            <p className="text-[16px] font-medium">Torana constructions</p>
          </div>

          <p className="text-sm mb-2">Get in touch</p>

          <div className="flex gap-5 mt-8 mr-2 text-[24px]">
            <a
              href="#"
              className="hover:text-yellow-400 hover:scale-110 transition"
            >
              <FaFacebookF />
            </a>
            <a
              href="#"
              className="hover:text-yellow-400 hover:scale-110 transition"
            >
              <FaInstagram />
            </a>
            <a
              href="#"
              className="hover:text-yellow-400 hover:scale-110 transition"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="#"
              className="hover:text-yellow-400 hover:scale-110 transition"
            >
              <FaYoutube />
            </a>
          </div>
        </div>

        {/* SERVICES */}
        <div className="flex flex-col gap-8">
          <h3 className="text-[18px] mb-2 font-semibold">Services</h3>
          <a href="#" className="text-sm opacity-90 hover:opacity-100">
            About us
          </a>
          <a href="#" className="text-sm opacity-90 hover:opacity-100">
            Our Projects
          </a>
          <a href="#" className="text-sm opacity-90 hover:opacity-100">
            Testimonial
          </a>
          <a href="#" className="text-sm opacity-90 hover:opacity-100">
            Blog & Articles
          </a>
        </div>

        {/* RESOURCES */}
        <div className="flex flex-col gap-8">
          <h3 className="text-[18px] mb-2 font-semibold">Resources</h3>
          <a href="#" className="text-sm opacity-90 hover:opacity-100">
            Blog & Articles
          </a>
          <a href="#" className="text-sm opacity-90 hover:opacity-100">
            Join as Architect
          </a>
        </div>

        {/* SUPPORT */}
        <div className="flex flex-col gap-8 max-w-[250px]">
          <h3 className="text-[18px] mb-2 font-semibold">Support</h3>

          <p className="text-sm opacity-90">We are available 24/7 on chat</p>

          <a
            href="#"
            className="text-yellow-400 font-medium hover:text-yellow-300 text-sm"
          >
            Click here to start chat
          </a>

          <p className="text-sm opacity-90">
            Email toranaconstructions@gmail.com
          </p>

          <a href="#" className="text-sm opacity-90 hover:opacity-100">
            Privacy policy
          </a>
        </div>
      </div>

      {/* BOTTOM */}
      <div className="mt-10 text-[12px] md:text-[13px] opacity-70 text-center md:text-left">
        © 2020-2024, Torana Constructions. All right reserved.
      </div>
    </footer>
  );
}

export default Footer;
